const n="\n  id\n  name\n";export{n as STOREFRONT_SELLING_PLAN_FRAGMENT};
//# sourceMappingURL=selling-plan.js.map
